<template>
  <v-container id="perdas-aic-historico" tag="section" fluid>
    <v-row>
      <v-col cols="12">
        <tabela
          :items="items"
          :loading="loading"
          @rechargeTable="getAll()"
          @switchProcessamentosExpirados="((processamentosExpirados = $event), getAll())"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
  
<script>
  import TesteQtdMatServService from '@/services/TesteQtdMatServService';
  import pusherMixins from '@/mixins/pusherMixins';
  import dayjs from 'dayjs';

  export default {
    components: {
      tabela: () => import('@/components/testeQtdMatServ/Tabela.vue')
    },
    mixins: [pusherMixins],

    data() {
      return {
        items: [],
        loading: false,
        processamentosExpirados: false
      };
    },

    mounted() {
      this.subscribe();
      this.getAll();
    },

    methods: {
      subscribe() {
        this.pusherChannel.bind('refreshTesteQtdMatServ', () => {
          this.getAll();
        });
      },
      getAll() {
        this.loading = true;

        TesteQtdMatServService.getAll(this.processamentosExpirados)
          .then((response) => {
            this.items = [];

            response.data.testes.forEach((element) => {
              this.items.push({
                id: element.id,
                titulo: element.titulo,
                obras: element.obras,
                tipo_base: element.tipo_base,
                status: element.status,
                usuario: element.usuario.nome,
                usuario_id: element.usuario.id,
                created: element.created,
                executed: element.data_processamento ? dayjs(element.data_processamento).format('DD/MM/YYYY HH:mm') : '-'
              });
            });
          })
          .catch((err) => {
            this.$toast.error('Erro ao recuperar os testes.', '', { position: 'topRight' });
            console.error(err);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  };
</script>
 
  